var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.isForbidden())?[(_vm.message)?_c('span',[_vm._v(_vm._s(_vm.message))]):_vm._e(),(!_vm.skipAlert)?_c('a-alert',{attrs:{"message":"Forbidden","type":"error"}}):_vm._e()]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }